// extracted by mini-css-extract-plugin
export default {"uploader":"uploader__o1ZOw","uploader_box":"uploader_box__0jnct","uploader_file":"uploader_file__tXg0R","uploader_error":"uploader_error__yhjpX","error":"error__jmry5"};